module.exports = __webpack_public_path__ + "static/media/risk_token_2.988f20d4.png";